import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { Subscription } from 'rxjs';
import { Student } from '../../../shared-components/student/student.model';
import { StudentDocuments } from '../../../shared-components/student/student-documents.model';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { SharedService } from '../../../shared-components/shared.service';
import { System } from '../../../shared-components/System';
import { StudentDocumentsFilteredComponent } from '../student-documents-filtered.component';
import { StudentAttachment } from '../../../shared-modules/student-attachment/student-attachment.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { Student360Service } from '../../student360.service';

@Component({
    selector: 'student-documents-v10',
    templateUrl: './student-documents-v10.component.html',
    styleUrls: ['./student-documents-v10.component.css']
})
export class StudentDocumentsV10Component extends StudentDocumentsFilteredComponent implements OnInit, OnDestroy {

    @ViewChild(MatSort) sort: MatSort;
    selectedStudentSubscription: Subscription;
    V10: boolean;
    selectedStudent: Student;
    columnsToDisplay = ['Name', 'DocumentType', 'FileType', 'Notes', 'CreatedOn'];

    constructor(
        studentService: StudentService,
        yearService: YearService,
        sharedService: SharedService,
        changeDetector: ChangeDetectorRef,
        private loginService: LoginService,
        student360Service: Student360Service
    ) {
        super(
            studentService,
            yearService,
            sharedService,
            changeDetector,
            student360Service
        );
    }

    ngOnInit() {
        this.V10 = this.loginService.LoginSettings.V10;
        this.selectedStudentSubscription = this.studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.studentDocuments = undefined;
                this.loadStudentInfo(studentId);
            });
    }

    ngOnDestroy(): void {
        this.selectedStudentSubscription.unsubscribe();
    }

    getStudentDocuments() {
        this.angularMatData.data = [];
        setTimeout(() => {
            this.studentService.getStudentDocuments(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
                this.studentDocuments = data;
                this.loadStudentDocuments();
            });
        }, 0);
    }

    loadStudentDocuments() {
        this.angularMatData.data = this.studentDocuments;
        this.applyFilter();
        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);
    }

    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.filter(function (student) {
            return student.Id == studentId;
        })[0];
        this.getStudentDocuments();
    }

    viewAttachment(row: StudentDocuments) {
        const studentAttachment: StudentAttachment = {
            DocumentId: this.V10 == false ? row.DocumentId : 0,
            DocumentName: row.Name,
            DocumentBase64: row.FileBase64,
            DocumentMimeType: row.FileMimeType,
            DocumentModuleName: 'Documents',
            ReportParameters: [],
            ReportType: 0
        };

        window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
        const win = window.open(System.baseUrl + 'studentattachment', '_blank');
        win.focus();
    }

    getAriaRow(row: StudentDocuments): string {
        let colList: string[] = [''];
        let dataList: string[] = [''];
        colList = ['File Name', 'Description', 'Category', 'For', 'Added', 'Added by'];
        dataList = [row.Name, row.Notes, row.DocumentType, row.DocumentFor, row.CreatedOn.toString(), row.CreatedBy];
        return AriaDirective.concatAriaStrings(colList, dataList);
    }
}
